import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { BindingCreator, createTranslatedText } from '@dreryk/react-common';
import { Select, useSelectContext } from '@dreryk/react-components';

import { createNfzDepartmentSelectFilter } from '~libs.shared.nfz';

import { translationKeys } from '../../../../translations';

import { getPatientNfzDepartmentLabel, nfzDepartmentsSearchCreator } from './PatientNfzDepartmentSelect.utils';

type PatientNfzDepartmentFormBeanPart = {
   nfzDepartment: NfzDepartment | null;
};

type PatientNfzDepartmentFieldProps = {
   readonly register: BindingCreator<PatientNfzDepartmentFormBeanPart>;
};

type DepartmentSelectListProps = {
   readonly departments: NfzDepartment[];
};

const PatientNfzDepartmentSelectList = (props: DepartmentSelectListProps): JSX.Element => {
   const { searchText } = useSelectContext();
   const filteredDepartments = props.departments.filter(createNfzDepartmentSelectFilter(searchText));

   if (!filteredDepartments.length) {
      return <Select.NoItems testId={'noNfzDepartments'} />;
   }

   return (
      <Select.List items={filteredDepartments} keyExtractor={'code'}>
         {(department) => (
            <Select.Item
               testId={department.code}
               item={department}
               label={<Select.Highlight node={createTranslatedText(getPatientNfzDepartmentLabel(department))} />}
            />
         )}
      </Select.List>
   );
};

export const PatientNfzDepartmentSelect = (props: PatientNfzDepartmentFieldProps): JSX.Element | null => {
   return (
      <Select<NfzDepartment>
         triggerLabelExtractor={getPatientNfzDepartmentLabel}
         controller={props.register('nfzDepartment', { required: true })}
         label={translationKeys.patientNfzDepartment}
         placeholder={translationKeys.choose}
         testId={'selectNfzDepartment'}
         searchInputEnabled
      >
         <Select.SearchCreator searchCreator={nfzDepartmentsSearchCreator}>
            {({ items }) => <PatientNfzDepartmentSelectList departments={items} />}
         </Select.SearchCreator>
      </Select>
   );
};
